// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forms-container {
  background: #15141d;
}

input {
  width: 100%;
  height: 50px;
  border-radius: 8px;
  outline: none;
  border: none;
  color: #fff;
  font-size: 1rem;
}

.form-success {
  text-align: center;
  font-size: 24px;
  margin-top: 80px;
  color: #fff;
}

.form-content-right {
  border-radius: 0 10px 10px 0;
  position: relative;
  background: linear-gradient(90deg, rgb(40, 40, 40) 0%, rgb(17, 17, 17) 100%);
}

.form-info {
  color: #fff;
  margin: 6rem auto;
  align-items: center;
  display: flex;
}

.form-inputs {
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%
    );
}

.form-input {
  display: block;
  outline: none;
  border-radius: 2px;
  height: 40px;
  width: 100%;
  border: none;
}

.form-input-btn {
  padding: 0.5rem 2rem;
  border-radius: 24px;
  background: linear-gradient(
    90deg,
    rgb(251, 133, 0, 1) 0%,
    rgb(230, 147, 39) 100%
  );
  outline: 1px white solid;
  border: none;
  color: #000000;
  font-family: Ezcar;
  font-size: 1rem;
  font-weight: 100;
}

.form-input-btn:hover {
  cursor: pointer;
  background: linear-gradient(
    90deg,
    rgb(255, 118, 39) 0%,
    rgba(223, 142, 49, 0.753) 100%
  );
  transition: all 0.4s ease-out;
}

.form-input-login {
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  font-family: Ezcar;
  color: #fff;
  width: 80%;
  text-align: center;
}

.form-input-login a {
  font-family: Ezcar;
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  text-decoration: none;
  color: #ff8f27;
  font-weight: 600;
}


.btn-container {
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  font-family: Ezcar;
}

.form-text {
  color: #fffbf7;
}

.form-text h4 {
  font-size: 24px;
  font-weight: 200;
  padding-top: 30px;
  padding-bottom: 14px;
  font-family: Ezcar;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Form.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,4EAA4E;AAC9E;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;;;;;KAKG;AACL;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB;;;;GAIC;EACD,wBAAwB;EACxB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf;;;;GAIC;EACD,6BAA6B;AAC/B;;AAEA;EACE;;;;;KAKG;EACH,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB;;;;;KAKG;EACH,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE;;;;;KAKG;EACH,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB","sourcesContent":[".forms-container {\n  background: #15141d;\n}\n\ninput {\n  width: 100%;\n  height: 50px;\n  border-radius: 8px;\n  outline: none;\n  border: none;\n  color: #fff;\n  font-size: 1rem;\n}\n\n.form-success {\n  text-align: center;\n  font-size: 24px;\n  margin-top: 80px;\n  color: #fff;\n}\n\n.form-content-right {\n  border-radius: 0 10px 10px 0;\n  position: relative;\n  background: linear-gradient(90deg, rgb(40, 40, 40) 0%, rgb(17, 17, 17) 100%);\n}\n\n.form-info {\n  color: #fff;\n  margin: 6rem auto;\n  align-items: center;\n  display: flex;\n}\n\n.form-inputs {\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n}\n\n.form-input {\n  display: block;\n  outline: none;\n  border-radius: 2px;\n  height: 40px;\n  width: 100%;\n  border: none;\n}\n\n.form-input-btn {\n  padding: 0.5rem 2rem;\n  border-radius: 24px;\n  background: linear-gradient(\n    90deg,\n    rgb(251, 133, 0, 1) 0%,\n    rgb(230, 147, 39) 100%\n  );\n  outline: 1px white solid;\n  border: none;\n  color: #000000;\n  font-family: Ezcar;\n  font-size: 1rem;\n  font-weight: 100;\n}\n\n.form-input-btn:hover {\n  cursor: pointer;\n  background: linear-gradient(\n    90deg,\n    rgb(255, 118, 39) 0%,\n    rgba(223, 142, 49, 0.753) 100%\n  );\n  transition: all 0.4s ease-out;\n}\n\n.form-input-login {\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n  font-family: Ezcar;\n  color: #fff;\n  width: 80%;\n  text-align: center;\n}\n\n.form-input-login a {\n  font-family: Ezcar;\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n  text-decoration: none;\n  color: #ff8f27;\n  font-weight: 600;\n}\n\n\n.btn-container {\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n  font-family: Ezcar;\n}\n\n.form-text {\n  color: #fffbf7;\n}\n\n.form-text h4 {\n  font-size: 24px;\n  font-weight: 200;\n  padding-top: 30px;\n  padding-bottom: 14px;\n  font-family: Ezcar;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
